import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';


import { Container, Row } from 'react-bootstrap';
import Navigation from './navigation';

import './header.scss';
export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      atturaLogo: file(
        relativePath: { eq: "atturra-logo-white.png" }
      ) {
        publicURL
      }
    }
  `);
  return (
    <header
      style={{
        boxShadow: '0px 5px 5px rgba(0,0,0,0.25)',
        position: 'relative',
        zIndex: 9998,
      }}
    >
      {/* Ticker Banner */}
      <Container
        fluid={true}
        style={{ backgroundColor: '#1b75bb', padding: '10px 15px' }}
        className="ticker-banner m-auto"
      >
        <Row className="banner-top">
          <div
            className="d-flex text-left banner-img-wrapper"
            style={{
              padding: '0px 15px',
              top: '34px',
              position: 'absolute',
            }}
          >
            <img
              className="banner-image"
              src={data.atturaLogo.publicURL}
              alt={'Atturra'}
            />
          </div>

          <div
            className="d-flex text-center banner-copy"
            style={{
              width: '100%',
              marginTop: '12px',
              padding: '0px 15px',
            }}
          >
            <p
              style={{ fontSize: '18px', color: '#ffffff' }}
              className="m-auto"
            >
              <strong>
                Veritec is now the Cloud & Applications arm
                of Atturra, formerly FTS Group.
              </strong>

              <a
                style={{
                  textTransform: 'initial',
                  margin: '0.5rem',
                }}
                href="https://atturra.com/au-en/press-room/fts-group-consolidation-rebrand-atturra"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-primary"
              >
                Find out more
              </a>
            </p>
          </div>
        </Row>
      </Container>
      <Navigation />
    </header>
  );
};
